export const hasSelectedOption = (
  selected: string[],
  optionId: string
): boolean => !!selected.find((opt) => opt === optionId);
